import React, {useState} from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@mui/material';
import {Box} from '@mui/system';
import {
  MainContainer,
  MainDocViewContainer
} from '@components/documents/DocumentsComponentStyles';
import SingleDocViewer from '@components/docViewer/SingleDocViewer';
import {LoadingButton} from '@mui/lab';

interface GlobalSearchDialogProps {
  // eslint-disable-next-line react/boolean-prop-naming
  open: boolean;
  onClose: () => void;
  rowData: Record<string, any>;
  subSectionData: any;
  module: string;
  sub_module: string;
}

const GlobalSearchDialog: React.FC<GlobalSearchDialogProps> = ({
  open,
  onClose,
  rowData,
  subSectionData,
  module,
  sub_module
}) => {
  const [docDownloadData, setDocDownloadData] = useState<string[] | null>([]);
  const [shoulddisplaymetainfo, setShoulddisplaymetainfo] =
    useState<boolean>(false);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        {subSectionData.heading || 'AI Document Viewer'}
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{display: 'flex', width: '100%'}}>
          <MainContainer>
            <MainDocViewContainer item xs={12}>
              <SingleDocViewer
                sectionUIData={subSectionData}
                customDocViewerActions={subSectionData.actions}
                rowData={rowData}
                module={module}
                sub_module={sub_module}
                refresh={true}
                docDownloadData={docDownloadData}
                setDocDownloadData={setDocDownloadData}
                shoulddisplaymetainfo={shoulddisplaymetainfo}
                setShoulddisplaymetainfo={setShoulddisplaymetainfo}
                height={'50vh'}
              />
            </MainDocViewContainer>
          </MainContainer>
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton type="button" variant="contained" onClick={onClose}>
          Close
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default GlobalSearchDialog;
